import * as React from 'react';
import { Flex } from 'antd';
import { Helmet } from 'react-helmet-async';
import dataMagazine from '../../magazine_data.json';
import { MagazineType } from '../../../../common/types';
import { MagazineCardItem } from '../card/MagazineCardItem';

interface TabProjectAwardsProps {
}

export const TabMagazine: React.FC<TabProjectAwardsProps> = () => {
  const mags = Array.from(Object.values(dataMagazine)) as MagazineType[];

  return (
        <>
            <Helmet>
                <title>MAGAZINES</title>
                <meta
                    name="description"
                    content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
                />
                <link rel="canonical" href='https://awmacbc.com/magazines'/>
            </Helmet>

            <Flex gap={20} wrap={'wrap'}>
                {
                    mags.map((mag) => <MagazineCardItem magazine={mag} key={mag.id}/>)
                }
            </Flex>
        </>
  );
};
